import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransactionsApi, type TransactionResponse, type UpdateTransactionRequest } from '@shared/api';

const updateTransactionEffect = createEffect((request: UpdateTransactionRequest) => TransactionsApi.updateTransaction(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransactionResponse | null>(null)
  .on(updateTransactionEffect.done, (current, result) => result.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateTransactionEffect.pending, (_, data) => data)
  .on(updateTransactionEffect.fail, () => false)
  .on(updateTransactionEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateTransactionEffect, () => null)
  .on(
    updateTransactionEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Transaction. Please try again.').message,
  )
  .on(updateTransactionEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $updateTransactionStore = {
  events: {
    updateTransaction: updateTransactionEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
